import $ from 'jquery';
import 'bootstrap';

const DATA_KEY = 'bs.modal';

export const EVENT_KEY = `.${DATA_KEY}`;
export const EVENT_HIDE = `hide${EVENT_KEY}`;
export const EVENT_HIDDEN = `hidden${EVENT_KEY}`;
export const EVENT_SHOW = `show${EVENT_KEY}`;
export const EVENT_SHOWN = `shown${EVENT_KEY}`;

export const Wrapper = {
	functional: true,
	render(h, { slots }) {
		return (
			<div class="modal fade">
				<div class="modal-dialog">
					<div class="modal-content">
						{ slots().default }
					</div>
				</div>
			</div>
		)
	}
}

export const Mixin = {
	methods: {
		show() {
			$(this.$el).modal('show');
		},
		hide() {
			$(this.$el).modal('hide');
		},
	},
	mounted() {
		$(this.$el).on('show.bs.modal', event => this.$emit('show', event));
		$(this.$el).on('shown.bs.modal', event => this.$emit('shown', event));
		$(this.$el).on('hide.bs.modal', event => this.$emit('hide', event));
		$(this.$el).on('hidden.bs.modal', event => this.$emit('hidden', event));
	},
	beforeDestroy() {
		$(this.$el).modal('dispose');
	},
}
